import * as actionTypes from "../types";

const initialState = {
    addedCategory: false,
    deletedCategory: false,
    updatedCategory: false,
    selectedCategory: {}, 
    categories: [],
    categoryEmpty: false,
    error: null
}

export default function categoryReducer(state=initialState, action){
    switch(action.type){
       
        case actionTypes.GET_CATEGORY: {
            return {
                ...state,
                categories: action.payload.categories,
                categoryEmpty: action.payload.categoryEmpty
            };
        }
        case actionTypes.SELECT_CATEGORY: {
            return {
                ...state,
                selectedCategory: action.payload,
            };
        }
        default: {
            return{
                ...state
            };
        }
    }
}


